export const MODULES = {
  USERS: "USERS",
  LOCATIONS: "LOCATIONS",
  PRODUCT_CREATOR: "PRODUCT_CREATOR",
  PRODUCT_EDITOR: "PRODUCT_EDITOR",
  PRODUCT_TYPES: "PRODUCT_TYPES",
  AGLC_PRICE_CHANGES: "AGLC_PRICE_CHANGES",
  ATS_COST_COMPARISON: "ATS_COST_COMPARISON",
  AGLC_PURCHASE_ORDERS: "AGLC_PURCHASE_ORDERS",
  UPDATE_COSTS: "UPDATE_COSTS",
  RETAIL_PRICE_TAGS: "RETAIL_PRICE_TAGS",
  COST_UPDATE_CSVS: "COST_UPDATE_CSVS",
  ATS: "ATS",
  STORE_PICKUP: "STORE_PICKUP",
  RECEIVING: "RECEIVING",
  VINTAGE_CHART: "VINTAGE_CHART",
  TASTINGS: "TASTINGS",
  CONTINUE_SELLING: "CONTINUE_SELLING",
  BUNDLES_CHANGELOG: "BUNDLES_CHANGELOG",
  UNITS_OF_MEASURE: "UNITS_OF_MEASURE",
  SIZES: "SIZES",
  PRESENTATIONS: "PRESENTATIONS",
  CATEGORIES: "CATEGORIES",
  CONTAINER_OPTIONS: "CONTAINER_OPTIONS",
  PRODUCERS: "PRODUCERS",
  SHOPIFY_BACKUPS: "SHOPIFY_BACKUPS",
  BUNDLES: "BUNDLES",
};

export const ROLE_PERMISSIONS = {
  admin: Object.values(MODULES),

  supervisor: [
    MODULES.LOCATIONS,
    MODULES.PRODUCT_CREATOR,
    MODULES.PRODUCT_EDITOR,
    MODULES.PRODUCT_TYPES,
    MODULES.AGLC_PURCHASE_ORDERS,
    MODULES.RETAIL_PRICE_TAGS,
    MODULES.ATS,
    MODULES.STORE_PICKUP,
    MODULES.RECEIVING,
    MODULES.VINTAGE_CHART,
    MODULES.TASTINGS,
    MODULES.UNITS_OF_MEASURE,
    MODULES.PRESENTATIONS,
    MODULES.SIZES,
    MODULES.CATEGORIES,
    MODULES.CONTAINER_OPTIONS,
    MODULES.PRODUCERS,
    MODULES.BUNDLES,
  ],

  warehouse: [
    MODULES.AGLC_PURCHASE_ORDERS,
    MODULES.RETAIL_PRICE_TAGS,
    MODULES.ATS,
    MODULES.STORE_PICKUP,
    MODULES.RECEIVING,
    MODULES.VINTAGE_CHART,
    MODULES.TASTINGS,
  ],

  retail: [
    MODULES.RETAIL_PRICE_TAGS,
    MODULES.ATS,
    MODULES.STORE_PICKUP,
    MODULES.VINTAGE_CHART,
    MODULES.TASTINGS,
  ],

  events: [
    MODULES.RETAIL_PRICE_TAGS,
    MODULES.ATS,
    MODULES.STORE_PICKUP,
    MODULES.VINTAGE_CHART,
    MODULES.TASTINGS,
  ],
};